import type { CustomLinkProps } from '@anchorage/utils';
import { parseSanitize } from '@anchorage/utils';
import { Text } from '@latitude/text';
import type { ComponentType } from 'react';

type Props = {
  title?: string | null;
  subtitle?: string | null;
  CustomLink?: ComponentType<CustomLinkProps>;
};

function PageHeader({ title, subtitle, CustomLink }: Props) {
  return (
    <div className="flex flex-col gap-2">
      <Text variant="headingLarge" data-testid="page-title">
        {title}
      </Text>
      {subtitle && (
        <Text variant="bodyRegular" data-testid="page-subtitle">
          {parseSanitize(subtitle, CustomLink)}
        </Text>
      )}
    </div>
  );
}

export { PageHeader };
